import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../static/icons/heart.svg'
import _imports_1 from '../static/icons/heart_filled.svg'


const _hoisted_1 = { class: "product-card__product-media" }
const _hoisted_2 = { class: "product-card__image-container" }
const _hoisted_3 = {
  key: 0,
  class: "product-card__product-label-container"
}
const _hoisted_4 = { class: "product-card__product-label" }
const _hoisted_5 = {
  key: 1,
  class: "product-card__product-incoming-container"
}
const _hoisted_6 = { class: "product-card__product-incoming" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "product-card__bottom" }
const _hoisted_9 = { class: "product-card__info" }
const _hoisted_10 = { class: "product-card__brand-name" }
const _hoisted_11 = { class: "product-card__name" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1
}

import { ref, computed } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useContext from '@/composables/useContext';
import useGiftCard from '@/composables/useGiftCard';
import { deviceWidths } from "../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
  product: {
    type: Object,
    required: true
  },
  categoryId: {
    type: String,
    default: null
  },
  productSections: {
    type: Array,
    default: []
  },
  tag: {
    type: Object,
    default: null
  },
  isFavoriteProduct: {
    type: Boolean,
    default: false,
  },
  showFavoriteProducts: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const highlightProductImgWidth = 
  ref(window.innerWidth).value < deviceWidths.phoneMaxWidth ?
    ref(window.innerWidth).value :
    ref(window.innerWidth).value / 2;
const regularProductImgWidth = highlightProductImgWidth / 2;

const props = __props;

const { toLitiumMediaUrl } = useContext();
const { websiteText } = useWebsiteTexts();
const { toggleFavoriteProduct } = useGiftCard();

const hover = ref(false);

const productUrl = computed(() => {
  if (!props.product?.url) return '';

  if (props.tag?.key && props.tag.value) {
    const sectionQueryParamValue = `${props.tag.key || ''}::${
      props.tag.value || ''
    }`;
    const sectionQueryParam = `?section=${encodeURIComponent(
      sectionQueryParamValue
    )}`;

    return `${props.product.url}${sectionQueryParam}`;
  }
  return props.product.url;
});

const productImageUrl = computed(() => {
  const width = props.product.highlighted
    ? highlightProductImgWidth
    : regularProductImgWidth;
  return toLitiumMediaUrl(
    (hover.value
      ? props.product?.secondaryImage
      : props.product?.primaryImage) ||
      props.product?.primaryImage ||
      props.product?.imageId ||
      props.product?.imageIds[0],
    {
      maxWidth: width
    }
  );
});

const productName = computed(() => {
  return props.product?.productName || props.product?.name || '';
});

const brandName = computed(() => {
  return props.product?.brandName || '';
});

const comingSoon = computed(() => {
  return props.product?.comingSoon || false;
});

const flags = computed(() => {
  return props.product?.productFlags || [];
});

const lowImpactFlag = computed(() => {
  return flags?.value.includes("PKLI");
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: productUrl.value,
    class: "product-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (lowImpactFlag.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('common_lowimpact').value), 1)
              ]))
            : _createCommentVNode("", true),
          (comingSoon.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(websiteText)('common_comingsoon').value), 1)
              ]))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "product-card__image-overlay" }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "product-card__image-spacer" }, null, -1)),
          (productImageUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false)),
                onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (hover.value = true)),
                onTouchend: _cache[3] || (_cache[3] = ($event: any) => (hover.value = false)),
                src: productImageUrl.value,
                class: _normalizeClass(["product-card__image", { 'product-card__image-incoming': comingSoon.value }])
              }, null, 42, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(brandName.value), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(productName.value), 1)
        ]),
        (__props.showFavoriteProducts)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product-card__favorite",
              onClick: _cache[4] || (_cache[4] = (event) => _unref(toggleFavoriteProduct)(event, __props.product))
            }, [
              (!__props.isFavoriteProduct)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true),
              (__props.isFavoriteProduct)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})